/* tslint:disable */
import { loadStyles } from '@microsoft/load-themed-styles';

const styles = {
  root: 'root_424a7653',
  group: 'group_424a7653',
  groupIsDropping: 'groupIsDropping_424a7653',
};

export = styles;

loadStyles([{"rawString":".root_424a7653{position:relative;font-size:12px}.group_424a7653{transition:background-color 267ms cubic-bezier(.445,.05,.55,.95)}.groupIsDropping_424a7653{background-color:"},{"theme":"neutralLight","defaultValue":"#eaeaea"},{"rawString":"}.root_424a7653 .ms-List-cell{min-height:36px}"}]);
/* tslint:enable */